import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsBand } from './components/sections/StatsBand';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { ImmediateAccess } from './components/sections/ImmediateAccess';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="3iiwdwl3utc1n">
      <MetaPixel data-id="element-1" data-mp="3ihv22ef0kliv" />
      <Hero data-id="element-2" data-mp="3mlj9mx3nbh44" />
      <main data-id="element-3" data-mp="3mlax56bfqdtg">
        <StatsBand data-id="element-4" data-mp="3mkrdnl64zhdb" />
        <BeforeAfter data-id="element-5" data-mp="3mk868ye44bdj" />
        <PainPoints data-id="element-6" data-mp="3mjq45l4rr2xp" />
        <Volumes data-id="element-7" data-mp="3rc9em985thya" />
        <ImmediateAccess data-id="element-8" data-mp="3rbr9en3irte8" />
        <Bonuses data-id="element-9" data-mp="3rdatkosaqola" />
        <Offer data-id="element-10" data-mp="3rcsulke91w9o" />
        <Guarantee data-id="element-11" data-mp="3reccfffk0fdk" />
        <Testimonials data-id="element-12" data-mp="5yh2n2cyzbp" />
        <About data-id="element-13" data-mp="67yvnd9206b" />
        <Faq data-id="element-14" data-mp="4n4pyuukj8z" />
        <FinalCta data-id="element-15" data-mp="5ggxfcks0yi" />
      </main>
      <Footer data-id="element-16" data-mp="2zl39tfhhuw2o" />
      <FloatingCta data-id="element-17" data-mp="2zld1r8m3ndb0" />
      <PurchasePopup data-id="element-18" data-mp="2zlv32jnmchps" />
    </div>;
}